import React from "react";
import { AccordionContext } from "./AccordionProvider";

export const useAccordionContext = () => {
    const context = React.useContext(AccordionContext);

    if (!context) {
        throw new Error("AccordionContext is not defined");
    }

    return context;
};
